module.exports = __webpack_public_path__ + "static/media/waveform-path.e7abc657.svg";